import React from "react"
import { isMobile } from "react-device-detect"
import { OtherBandsSection } from "../../../bands/OtherBandsSection"
import { PostSection } from "../../../bands/PostSection"
import BandHeader from "../../BandHeader"
import { Followings } from "../../../Following"
import type { Band } from "../../../../types/bands"

interface BasicTemplateProps {
  band: Band
}

const BasicTemplate: React.FC<BasicTemplateProps> = ({ band }) => {
  const isFan = band.band_type === "fan"
  return (
    <div className="col-span-12">
      <BandHeader band={band} headerMode="classic" />

      <div
        className="px-3 lg:px-4"
        style={{
          marginTop: isMobile ? "" : "-13vw",
        }}
      >
        {isFan ? (
          <div className="lg:mt-64">
            <Followings bandId={String(band.id)} />
          </div>
        ) : (
          <>
            <PostSection
              title="Upcoming Shows"
              bandId={band.id}
              bandName={band.name}
              contentType="future_concerts"
              pageSize={20}
              colClass="lg:grid-cols-2 grid-cols-1"
            />
            <PostSection
              title="Posts"
              bandId={band.id}
              bandName={band.name}
              contentType="headlines"
              colClass="lg:grid-cols-2 grid-cols-1"
            />
            <PostSection
              title="Music"
              bandId={band.id}
              bandName={band.name}
              contentType="albums"
              colClass="lg:grid-cols-2 grid-cols-1"
            />
            <PostSection
              title="Video"
              bandId={band.id}
              bandName={band.name}
              contentType="videos"
              colClass="lg:grid-cols-2 grid-cols-1"
            />
            <OtherBandsSection
              bandId={String(band.id)}
              bandName={band.name}
              colClass="lg:grid-cols-8 grid-cols-2"
            />
            <PostSection
              title="Past Shows"
              bandId={band.id}
              bandName={band.name}
              contentType="past_concerts"
              colClass="lg:grid-cols-2 grid-cols-1"
            />
          </>
        )}
      </div>
    </div>
  )
}

export default BasicTemplate
